export interface IPer {
  num: number
}
export function iamts(num: number, s: string): string {
  return `${num} --- ${s}`
}